import { render, staticRenderFns } from "./AddEventAmenities.vue?vue&type=template&id=49649d50&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddEventAmenities.vue"
export default component.exports